
import { images } from ".";

const vendors = [
    {
        id: 1,
        image: images.floral1,
        title: "Floral Bliss",
        content: "Floral Bliss specializes in crafting stunning floral designs that elevate your wedding experience, from breathtaking bouquets to elegant centerpieces.",
        details: {
            category: "Floral Design",
            phoneNumber: "(555) 123-4567",
            email: "events@floralbliss.com",
            website: "www.floralbliss.com",
            location: "Rosewood Gardens, 456 Amour Avenue",
            priceRange: "$2,500 - $5,000",
            availability: "Available for weddings, corporate events, and private parties",
            specialties: "Wedding floral arrangements, luxury centerpieces, custom bouquets",
            businessHours: "Mon - Sat: 9:00 AM - 6:00 PM"
        },
        overviews: [
            "Welcome to Floral Bliss! We specialize in crafting stunning floral designs that elevate your wedding experience. Our team is dedicated to bringing your floral vision to life, ensuring every arrangement is perfect for your special day.",
            "From breathtaking bouquets to elegant centerpieces, Floral Bliss is here to transform your wedding with the beauty of flowers."
        ],
        experience: [
            "Custom Floral Arrangements",
            "Expert Floral Design Consultation",
            "On-site Floral Setup",
            "Professional and Friendly Staff",
            "Attention to Detail and Quality"
        ],
        services: [
            "Personalized Floral Designs",
            "Stress-Free Planning Process",
            "Seamless Coordination on Your Big Day",
            "Memorable Floral Experiences for Guests",
            "Commitment to Freshness and Quality"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Floral Bliss for my wedding?",
                content: "Booking Floral Bliss is easy! Simply reach out through our website, fill out the contact form, or give us a call. We'll arrange a consultation to discuss your floral needs and vision."
            },
            {
                id: 2,
                heading: "What payment methods do you accept?",
                content: "We accept various payment methods including credit/debit cards, bank transfers, and mobile payments. Our team will inform you about the best options during your consultation."
            },
            {
                id: 3,
                heading: "What is your cancellation policy?",
                content: "You can cancel your booking without a fee up to 60 days before your wedding date. After this time, a cancellation fee may apply based on the services already arranged."
            },
            {
                id: 4,
                heading: "What floral services do you offer?",
                content: "We offer a comprehensive range of floral services, including custom bouquets, centerpieces, floral arches, and on-site setup. Our services are tailored to meet your specific wedding needs."
            },
            {
                id: 5,
                heading: "Can I customize my floral arrangements?",
                content: "Absolutely! We work closely with you to create floral arrangements that reflect your style and preferences, ensuring that every detail is aligned with your vision."
            },
            {
                id: 6,
                heading: "Do you offer delivery services?",
                content: "Yes, we provide delivery services to ensure your floral arrangements arrive fresh and on time. Delivery fees may vary based on the location and timing."
            },
            {
                id: 7,
                heading: "What does the consultation process involve?",
                content: "During the consultation, we discuss your wedding theme, color palette, and floral preferences. We'll also provide you with suggestions and ideas to create the perfect arrangements for your special day."
            },
            {
                id: 8,
                heading: "Are there specific flowers I should consider for my wedding?",
                content: "Flower availability can vary by season. We will guide you in selecting blooms that are in season, as well as discuss your preferred flowers to ensure you have the best options for your wedding day."
            },
            {
                id: 9,
                heading: "Do you provide on-site setup for floral arrangements?",
                content: "Yes, our team is happy to provide on-site setup for your floral arrangements to ensure everything looks perfect on your wedding day. This service can be included in your package."
            },
            {
                id: 10,
                heading: "Do you offer post-wedding services for my floral arrangements?",
                content: "We can help you with post-wedding services such as preserving your bouquet or providing suggestions for donating flowers to local hospitals or charities after your event."
            }
        ],
        location: {
            description: "Explore our location and see how we can bring your floral dreams to life. Visit us or contact us to discuss your upcoming event! Our experienced team is here to guide you through every step of the process, from initial consultation to final setup. Feel free to stop by for a personalized consultation or to browse our portfolio of previous work.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317716.6065440981!2d-0.4312527129418162!3d51.528606999961184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2s!4v1727192621929!5m2!1sen!2s"
        },
        gallery: [
            images.floral1Gallery1,
            images.floral1Gallery2,
            images.floral1Gallery3,
            images.floral1Gallery4,
            images.floral1Gallery5,
            images.floral1Gallery6,
            images.floral1Gallery7,
            images.floral1Gallery8,
            images.floral1Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.floral1Review1,
                name: "Sarah Miller",
                date: "April 5, 2024",
                rating: 5,
                content: "Floral Bliss transformed our wedding with breathtaking arrangements! Their attention to detail was incredible, and our guests couldn't stop complimenting the flowers."
            },
            {
                id: 2,
                image: images.floral1Review2,
                name: "James Taylor",
                date: "April 10, 2024",
                rating: 4.9,
                content: "The floral arrangements were stunning and perfectly matched our wedding theme. Thank you, Floral Bliss, for making our day so special!"
            }
        ]
    },
    {
        id: 2,
        image: images.floral2,
        title: "Petal Paradise",
        content: "Petal Paradise offers artistic and bespoke floral designs tailored to create magical moments for weddings, private parties, and corporate events in Los Angeles.",
        details: {
            category: "Floral Design",
            phoneNumber: "(555) 987-6543",
            email: "contact@petalparadise.com",
            website: "www.petalparadise.com",
            location: "Sunset Boulevard, Los Angeles, CA",
            priceRange: "$2,000 - $4,500",
            availability: "Available for weddings, private events, and corporate functions",
            specialties: "Custom floral art, event styling, eco-friendly arrangements",
            businessHours: "Mon - Fri: 10:00 AM - 5:00 PM"
        },
        overviews: [
            "Welcome to Petal Paradise, where floral artistry meets elegance. We’re passionate about curating one-of-a-kind floral experiences that reflect your vision and personality.",
            "Our designs are crafted with love and attention, using fresh, locally sourced blooms to ensure your event feels vibrant and unforgettable."
        ],
        experience: [
            "Bespoke Floral Styling",
            "Creative Concept Consultation",
            "Eco-Conscious Floral Options",
            "Timely and Reliable Service",
            "Floral Décor for All Event Sizes"
        ],
        services: [
            "Custom Floral Installations",
            "Event Design Consultations",
            "Sustainable Flower Sourcing",
            "Complete Setup & Breakdown",
            "Floral Decor for All Themes"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book Petal Paradise?",
                content: "Reach out via our website or call us directly to schedule a consultation. We’ll walk you through the process and begin planning your floral designs."
            },
            {
                id: 2,
                heading: "What is included in the floral package?",
                content: "Our packages typically include bridal bouquets, boutonnieres, ceremony décor, centerpieces, and delivery/setup. We tailor each package to fit your event’s needs."
            },
            {
                id: 3,
                heading: "Do you offer same-day delivery for arrangements?",
                content: "While we specialize in event florals, we do offer limited same-day delivery services in Los Angeles for select floral arrangements. Please contact us for availability."
            },
            {
                id: 4,
                heading: "Can I choose specific flowers?",
                content: "Absolutely! We collaborate with you to ensure your favorite blooms and color themes are included, depending on seasonal availability."
            },
            {
                id: 5,
                heading: "Do you handle venue setup?",
                content: "Yes, our team handles full floral setup at your venue to ensure every arrangement looks perfect and cohesive with your event theme."
            }
        ],
        location: {
            description: "Visit our design studio in Los Angeles or schedule a virtual consultation to explore how we can bring your floral vision to life. We welcome you to browse our portfolio and discuss ideas that match your dream event.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.968793765509!2d-118.35543568478364!3d34.09800388059043!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c09d72571bd1%3A0x3f0e8f577c6fc53d!2sSunset%20Blvd%2C%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2sus!4v1727193000000!5m2!1sen!2sus"
        },
        gallery: [
            images.floral2Gallery1,
            images.floral2Gallery2,
            images.floral2Gallery3,
            images.floral2Gallery4,
            images.floral2Gallery5,
            images.floral2Gallery6,
            images.floral2Gallery7,
            images.floral2Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.floral2Review1,
                name: "Olivia Johnson",
                date: "March 22, 2024",
                rating: 4.8,
                content: "Petal Paradise made our wedding day unforgettable. The floral arrangements were fresh, lush, and absolutely breathtaking!"
            },
            {
                id: 2,
                image: images.floral2Review2,
                name: "Ethan Brooks",
                date: "April 2, 2024",
                rating: 4.6,
                content: "Very professional and talented team. Their attention to detail and eco-friendly approach really impressed us."
            }
        ]
    },
    {
        id: 3,
        image: images.floral3,
        title: "Rose Garden",
        content: "Rose Garden brings timeless beauty to your event with exquisite floral artistry. From romantic arrangements to luxurious centerpieces, we design with passion and elegance.",
        details: {
            category: "Floral Design",
            phoneNumber: "(555) 345-6789",
            email: "info@rosegardenparis.com",
            website: "www.rosegardenparis.com",
            location: "Champs-Élysées, Paris, France",
            priceRange: "$2,800 - $5,200",
            availability: "Available for weddings, corporate events, and exclusive parties",
            specialties: "Romantic bouquets, Parisian-style arrangements, custom floral art",
            businessHours: "Mon - Sat: 10:00 AM - 7:00 PM"
        },
        overviews: [
            "Welcome to Rose Garden, your premier floral design destination in Paris. We specialize in creating breathtaking arrangements that capture the essence of romance and style.",
            "Whether you're planning a wedding or a private celebration, our expert florists are here to design floral experiences that are elegant, timeless, and unforgettable."
        ],
        experience: [
            "Parisian Floral Expertise",
            "Elegant Event Styling",
            "Seasonal Floral Selections",
            "Artistic Design Team",
            "High-End Floral Installations"
        ],
        services: [
            "Tailored Floral Concepts",
            "Luxury Floral Styling",
            "Seamless Venue Coordination",
            "On-site Floral Setup",
            "Bouquet Preservation Options"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Rose Garden for my event?",
                content: "To book Rose Garden, visit our website or contact us via phone or email. We'll schedule a consultation to explore your floral preferences and event details."
            },
            {
                id: 2,
                heading: "Do you provide delivery and setup?",
                content: "Yes, we offer full delivery and on-site setup services within Paris and nearby regions. Our team ensures your florals are perfectly placed and styled."
            },
            {
                id: 3,
                heading: "Can you create custom arrangements?",
                content: "Absolutely. We collaborate closely with our clients to design custom arrangements that suit your vision, color palette, and venue style."
            },
            {
                id: 4,
                heading: "What types of events do you service?",
                content: "We design florals for weddings, private parties, galas, corporate events, and more. Each event is uniquely styled to match your theme."
            },
            {
                id: 5,
                heading: "Are consultations available in person?",
                content: "Yes, we welcome in-person consultations at our Paris studio by appointment. Virtual consultations are also available upon request."
            }
        ],
        location: {
            description: "Come visit our Parisian studio and experience floral elegance like never before. We welcome you to consult with our expert designers and explore our past event creations in a beautiful, tranquil setting.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.9994529471933!2d2.292292715674685!3d48.85884407928759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66fda4e6b6a8d%3A0x1c7b2e7f7e57f50!2sParis%2C%20France!5e0!3m2!1sen!2s!4v1727199999999!5m2!1sen!2s"
        },
        gallery: [
            images.floral3Gallery1,
            images.floral3Gallery2,
            images.floral3Gallery3,
            images.floral3Gallery4,
            images.floral3Gallery5,
            images.floral3Gallery6,
            images.floral3Gallery7,
            images.floral3Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.floral3Review1,
                name: "Chloe Bernard",
                date: "May 2, 2024",
                rating: 5,
                content: "Rose Garden made my Paris wedding magical with the most stunning florals I’ve ever seen. Everything was flawless!"
            },
            {
                id: 2,
                image: images.floral3Review2,
                name: "Louis Moreau",
                date: "May 4, 2024",
                rating: 4.8,
                content: "Incredible attention to detail and artistry! The floral designs truly elevated our entire event. Highly recommended!"
            }
        ]
    },
    {
        id: 4,
        image: images.floral4,
        title: "Lily & Leaf",
        content: "Lily & Leaf curates enchanting floral arrangements inspired by nature’s finest details. With a modern British touch, we deliver fresh, stylish blooms for every occasion.",
        details: {
            category: "Floral Design",
            phoneNumber: "(020) 7654 3210",
            email: "hello@lilyleaf.co.uk",
            website: "www.lilyleaf.co.uk",
            location: "Notting Hill, London, UK",
            priceRange: "£1,900 - £4,500",
            availability: "Available for weddings, corporate gatherings, and bespoke events",
            specialties: "Modern floral design, eco-conscious arrangements, seasonal selections",
            businessHours: "Mon - Fri: 9:00 AM - 6:00 PM"
        },
        overviews: [
            "Lily & Leaf is a premier London-based floral design studio known for its artistic arrangements and signature British flair. We offer personalized floral styling that adds charm and freshness to your celebration.",
            "Our floral designers focus on sustainability, creativity, and tailoring each bouquet or installation to your vision. We pride ourselves on turning ordinary spaces into extraordinary floral landscapes."
        ],
        experience: [
            "Award-Winning Florists",
            "Eco-Friendly Practices",
            "Seasonal Flower Experts",
            "Stylish British Aesthetic",
            "Over 10 Years of Experience"
        ],
        services: [
            "Floral Consultation",
            "Custom Bouquet Creation",
            "Venue Floral Styling",
            "Green Event Options",
            "On-site Setup & Delivery"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book Lily & Leaf for my event?",
                content: "Bookings can be made through our website or by contacting us via phone or email. We'll arrange a consultation to discuss your event needs and vision."
            },
            {
                id: 2,
                heading: "Do you offer environmentally friendly floral options?",
                content: "Yes, we specialize in eco-conscious arrangements using locally sourced, seasonal flowers and sustainable materials."
            },
            {
                id: 3,
                heading: "Do you design for small and large-scale events?",
                content: "Absolutely. We cater to intimate gatherings as well as large weddings and corporate functions with tailored floral solutions for all sizes."
            },
            {
                id: 4,
                heading: "Can I visit your studio for a consultation?",
                content: "Yes, we offer in-person consultations at our London studio. Please book an appointment in advance via our website or phone."
            },
            {
                id: 5,
                heading: "Do you handle floral delivery and setup?",
                content: "Yes, we provide full delivery and on-site setup services across London and nearby areas."
            }
        ],
        location: {
            description: "Lily & Leaf welcomes you to our charming studio in Notting Hill. Whether you're dreaming of whimsical bouquets or modern arrangements, let’s bring your floral vision to life.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19804.668412888566!2d-0.21090723749685137!3d51.509030518996745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760fe5d81ecfd5%3A0x9f4b69b68f3d8b89!2sNotting%20Hill%2C%20London%2C%20UK!5e0!3m2!1sen!2s!4v1727200000000!5m2!1sen!2s"
        },
        gallery: [
            images.floral4Gallery1,
            images.floral4Gallery2,
            images.floral4Gallery3,
            images.floral4Gallery4,
            images.floral4Gallery5,
            images.floral4Gallery6,
            images.floral4Gallery7,
            images.floral4Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.floral4Review1,
                name: "Emily Watson",
                date: "April 18, 2024",
                rating: 4.7,
                content: "Lily & Leaf added pure elegance to our engagement party. The arrangements were fresh, lush, and totally stunning!"
            },
            {
                id: 2,
                image: images.floral4Review2,
                name: "Oliver Bennett",
                date: "April 22, 2024",
                rating: 4.6,
                content: "Excellent service, beautiful designs, and a pleasure to work with. Highly recommend for anyone planning a London event."
            }
        ]
    },
    {
        id: 5,
        image: images.catering1,
        title: "Savory Spoon",
        content: "Savory Spoon delivers gourmet catering experiences with a creative twist. From intimate dinners to grand celebrations, we serve exceptional dishes that leave a lasting impression.",
        details: {
            category: "Catering Services",
            phoneNumber: "(312) 555-8765",
            email: "events@savoryspoon.com",
            website: "www.savoryspoon.com",
            location: "Chicago, IL, USA",
            priceRange: "$2,500 - $8,000",
            availability: "Available for weddings, private parties, and corporate events",
            specialties: "Gourmet menus, live cooking stations, custom event themes",
            businessHours: "Mon - Sat: 10:00 AM - 8:00 PM"
        },
        overviews: [
            "At Savory Spoon, every plate tells a story. We combine fresh ingredients, creative flair, and expert planning to craft catering experiences that delight the senses and exceed expectations.",
            "Our culinary team works closely with clients to develop personalized menus, accommodating a range of dietary needs and themes for a truly tailored event."
        ],
        experience: [
            "Award-Winning Chefs",
            "Farm-to-Table Ingredients",
            "Customized Menu Planning",
            "Live Culinary Experiences",
            "Over 12 Years in Catering"
        ],
        services: [
            "Full-Service Catering",
            "Buffet & Plated Meals",
            "Live Food Stations",
            "Beverage & Bar Service",
            "Staffing & Rentals"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book Savory Spoon for my event?",
                content: "You can reach out via our website or phone to schedule a consultation. We'll help plan your menu and logistics from start to finish."
            },
            {
                id: 2,
                heading: "Do you provide customized menus?",
                content: "Absolutely. All our menus are tailored to your preferences, event style, and dietary needs."
            },
            {
                id: 3,
                heading: "Do you cater to dietary restrictions?",
                content: "Yes, we offer vegetarian, vegan, gluten-free, and allergy-sensitive menu options."
            },
            {
                id: 4,
                heading: "Can you handle both small and large events?",
                content: "Yes, we cater events of all sizes—from private dinners for 10 to weddings and corporate events for 500+ guests."
            },
            {
                id: 5,
                heading: "Do you offer event rentals?",
                content: "Yes, we provide event rentals including tables, chairs, linens, and dinnerware as part of our full-service package."
            }
        ],
        location: {
            description: "Visit our test kitchen in downtown Chicago or let us bring the experience to your venue. We travel throughout the Chicago area and surrounding states.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.112317594668!2d-87.62979868461957!3d41.87811377922116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e2cbbadf2a7d5%3A0xf95c71b6b4e7f9a5!2sChicago%2C%20IL%2C%20USA!5e0!3m2!1sen!2s!4v1727250000000!5m2!1sen!2s"
        },
        gallery: [
            images.catering1Gallery1,
            images.catering1Gallery2,
            images.catering1Gallery3,
            images.catering1Gallery4,
            images.catering1Gallery5,
            images.catering1Gallery6,
            images.catering1Gallery7,
            images.catering1Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.catering1Review1,
                name: "Danielle Brooks",
                date: "March 12, 2024",
                rating: 4.9,
                content: "Our wedding menu was phenomenal. Every guest raved about the food. Truly an unforgettable experience!"
            },
            {
                id: 2,
                image: images.catering1Review2,
                name: "Marcus Lin",
                date: "March 28, 2024",
                rating: 4.8,
                content: "Professional, punctual, and delicious. Savory Spoon took care of everything and made our event seamless and flavorful."
            }
        ]
    },
    {
        id: 6,
        image: images.catering2,
        title: "Feast Events",
        content: "Feast Events curates elegant and unforgettable catering experiences for weddings, galas, and private celebrations. Their refined menus and attentive service set the stage for memorable gatherings.",
        details: {
            category: "Catering Services",
            phoneNumber: "(646) 555-2389",
            email: "contact@feastevents.com",
            website: "www.feastevents.com",
            location: "New York, NY, USA",
            priceRange: "$3,000 - $10,000",
            availability: "Available for weddings, private events, and corporate functions",
            specialties: "Elegant plated dinners, gourmet buffets, themed décor integration",
            businessHours: "Mon - Fri: 9:00 AM - 6:00 PM"
        },
        overviews: [
            "Feast Events specializes in transforming events into culinary showcases. With a passion for presentation and flavor, they craft menus that elevate every occasion.",
            "Their team brings years of hospitality experience, working closely with clients to match every bite to the mood and aesthetic of the event."
        ],
        experience: [
            "Luxury Event Catering",
            "Gourmet Cuisine Experts",
            "Experienced Event Planners",
            "Bespoke Menu Creation",
            "15+ Years of Excellence"
        ],
        services: [
            "Wedding Catering",
            "Corporate Events",
            "Cocktail Receptions",
            "Themed Food Stations",
            "Full Staff & Rentals"
        ],
        faqs: [
            {
                id: 1,
                heading: "Do you provide tasting sessions?",
                content: "Yes, we offer private tasting appointments to help finalize your menu and experience our service firsthand."
            },
            {
                id: 2,
                heading: "Can you handle luxury and large-scale events?",
                content: "Absolutely. We specialize in high-end events and can cater to over 1000 guests with seamless execution."
            },
            {
                id: 3,
                heading: "Do you provide bar and beverage services?",
                content: "Yes, we offer full bar services including custom cocktails, wine pairings, and professional bartenders."
            },
            {
                id: 4,
                heading: "Are rentals included?",
                content: "We provide rentals such as tables, linens, dinnerware, and décor setup as part of our packages."
            },
            {
                id: 5,
                heading: "Do you accommodate themed events?",
                content: "Yes, our culinary and décor team can work around any event theme or concept."
            }
        ],
        location: {
            description: "Our office and tasting room are located in the heart of Manhattan, and we cater events across New York City and surrounding areas.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.901315495603!2d-74.00601528459561!3d40.71277617933042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a19c1e3e3f5%3A0xbbb2a8a0ec4e7e9e!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1727250000000!5m2!1sen!2s"
        },
        gallery: [
            images.catering2Gallery1,
            images.catering2Gallery2,
            images.catering2Gallery3,
            images.catering2Gallery4,
            images.catering2Gallery5,
            images.catering2Gallery6,
            images.catering2Gallery7,
            images.catering2Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.catering2Review1,
                name: "Jasmine Carter",
                date: "April 9, 2024",
                rating: 5.0,
                content: "Feast Events delivered an extraordinary experience. Every detail was flawless, and the food was divine."
            },
            {
                id: 2,
                image: images.catering2Review2,
                name: "Elliot Romero",
                date: "April 21, 2024",
                rating: 4.9,
                content: "A truly elegant catering service. They exceeded expectations from planning to execution. Highly recommend!"
            }
        ]
    },
    {
        id: 7,
        image: images.catering3,
        title: "Gourmet Table",
        content: "Gourmet Table offers upscale catering with a flair for global cuisine. From intimate soirées to large-scale galas, their team crafts unforgettable dining experiences.",
        details: {
            category: "Catering Services",
            phoneNumber: "(213) 555-7890",
            email: "hello@gourmettable.com",
            website: "www.gourmettable.com",
            location: "Los Angeles, CA, USA",
            priceRange: "$2,500 - $12,000",
            availability: "Available for private parties, weddings, and corporate functions",
            specialties: "International fusion cuisine, interactive chef stations, luxury presentation",
            businessHours: "Mon - Sat: 10:00 AM - 7:00 PM"
        },
        overviews: [
            "Gourmet Table blends culinary artistry with world-class service. Their chefs design bold, globally inspired menus tailored to each event’s vision.",
            "From stylish plating to personalized themes, every detail is curated to elevate the guest experience and make your event truly memorable."
        ],
        experience: [
            "International Menu Curation",
            "Luxury Catering Solutions",
            "Custom Event Styling",
            "Live Cooking Stations",
            "10+ Years in Catering"
        ],
        services: [
            "Wedding Catering",
            "Private Chef Services",
            "Buffet & Plated Meals",
            "Corporate Luncheons",
            "Beverage Packages"
        ],
        faqs: [
            {
                id: 1,
                heading: "Do you customize menus?",
                content: "Absolutely. We work closely with clients to create customized menus based on dietary preferences and event themes."
            },
            {
                id: 2,
                heading: "Is staff included in the service?",
                content: "Yes, our professional chefs, servers, and coordinators are included in our full-service catering packages."
            },
            {
                id: 3,
                heading: "Can you provide international cuisine?",
                content: "Yes, we specialize in globally inspired dishes and can create menus that reflect any cultural or regional preference."
            },
            {
                id: 4,
                heading: "What is your booking process?",
                content: "We begin with a consultation, followed by a proposal. Once the deposit is paid, your date is secured on our calendar."
            },
            {
                id: 5,
                heading: "Do you offer vegetarian or vegan options?",
                content: "Yes, we have a wide range of plant-based dishes and can design a fully vegetarian or vegan menu if needed."
            }
        ],
        location: {
            description: "Gourmet Table operates throughout Los Angeles and surrounding areas. Visit our tasting kitchen or schedule an on-site consultation.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3301.947297746205!2d-118.2436842847842!3d34.05223427960971!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c7b76cf132c1%3A0xf1dd4c1f82efccb5!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1727260000000!5m2!1sen!2s"
        },
        gallery: [
            images.catering3Gallery1,
            images.catering3Gallery2,
            images.catering3Gallery3,
            images.catering3Gallery4,
            images.catering3Gallery5,
            images.catering3Gallery6,
            images.catering3Gallery7,
            images.catering3Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.catering3Review1,
                name: "Michael Lang",
                date: "March 18, 2024",
                rating: 4.8,
                content: "Outstanding service and flavors! Gourmet Table turned our event into a fine dining experience. Guests loved every dish."
            },
            {
                id: 2,
                image: images.catering3Review2,
                name: "Clara Weiss",
                date: "April 2, 2024",
                rating: 4.7,
                content: "Professional team, elegant setup, and delicious food. Truly exceeded our expectations for our wedding catering."
            }
        ]
    },
    {
        id: 8,
        image: images.catering4,
        title: "Elegant Bites",
        content: "Elegant Bites brings sophistication and flavor together, offering exquisite catering services tailored to your event's needs. Whether it's a corporate luncheon or a grand celebration, they deliver culinary excellence.",
        details: {
            category: "Catering Services",
            phoneNumber: "(415) 555-1023",
            email: "info@elegantbites.com",
            website: "www.elegantbites.com",
            location: "San Francisco, CA, USA",
            priceRange: "$3,000 - $10,000",
            availability: "Available for weddings, private parties, and corporate events",
            specialties: "Gourmet hors d'oeuvres, elegant plated meals, custom dessert stations",
            businessHours: "Mon - Fri: 8:00 AM - 6:00 PM"
        },
        overviews: [
            "Elegant Bites is known for its meticulous attention to detail and upscale cuisine. Their team ensures that every meal served at your event is crafted to perfection.",
            "From intimate gatherings to large celebrations, Elegant Bites offers an unforgettable dining experience with top-tier service and presentation."
        ],
        experience: [
            "Exquisite Menu Crafting",
            "Tailored Event Planning",
            "Full-Service Catering",
            "Luxury Dining Experience",
            "10+ Years of Excellence"
        ],
        services: [
            "Wedding Catering",
            "Corporate Catering",
            "Gourmet Platters",
            "Dessert Stations",
            "Custom Menus"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Elegant Bites for my event?",
                content: "Booking Elegant Bites is simple. You can reach us through our website to request a quote, or give us a call to discuss your event details and schedule a consultation."
            },
            {
                id: 2,
                heading: "Do you accommodate dietary restrictions?",
                content: "Yes, we offer a variety of options including gluten-free, vegetarian, vegan, and other dietary preferences. Let us know your requirements, and we'll tailor the menu accordingly."
            },
            {
                id: 3,
                heading: "What types of events do you cater?",
                content: "We cater a wide range of events including weddings, corporate functions, private parties, and social gatherings. No event is too small or too large for us to handle."
            },
            {
                id: 4,
                heading: "Is the service staff included?",
                content: "Yes, our service staff is included in our full-service packages. They will ensure your event runs smoothly and provide excellent service to your guests."
            },
            {
                id: 5,
                heading: "Do you offer food tastings?",
                content: "Yes, we offer food tastings to help you select the perfect dishes for your event. Our chefs will work with you to create a personalized menu that fits your tastes."
            }
        ],
        location: {
            description: "Elegant Bites is located in the heart of San Francisco. Visit us for a consultation or explore our portfolio of past events. We look forward to creating a memorable dining experience for your special occasion.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.318804024115!2d-122.41941548491876!3d37.77492962928909!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858064d21c8b0f%3A0xf2b9d51be846f42a!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1727260000000!5m2!1sen!2s"
        },
        gallery: [
            images.catering4Gallery1,
            images.catering4Gallery2,
            images.catering4Gallery3,
            images.catering4Gallery4,
            images.catering4Gallery5,
            images.catering4Gallery6,
            images.catering4Gallery7,
            images.catering4Gallery8,
        ],
        comments: [
            {
                id: 1,
                image: images.catering4Review1,
                name: "Sophia Grant",
                date: "May 5, 2024",
                rating: 4.8,
                content: "Elegant Bites made our wedding reception unforgettable! The food was divine, and the service was impeccable. Our guests couldn't stop talking about it."
            },
            {
                id: 2,
                image: images.catering4Review2,
                name: "David Richards",
                date: "May 12, 2024",
                rating: 4.6,
                content: "A truly elegant catering experience. From the appetizers to the main course, everything was prepared beautifully and tasted amazing. Highly recommend!"
            }
        ]
    },
    {
        id: 9,
        image: images.photography1,
        title: "Snap Story",
        content: "Snap Story captures the essence of your event through stunning photography. From candid moments to posed shots, they provide high-quality images that tell your story beautifully.",
        details: {
            category: "Event Photography",
            phoneNumber: "(123) 456-7890",
            email: "info@snapstory.com",
            website: "www.snapstory.com",
            location: "New York, NY, USA",
            priceRange: "$1,500 - $5,000",
            availability: "Available for weddings, corporate events, parties, and more",
            specialties: "Candid wedding photography, event coverage, custom photo albums",
            businessHours: "Mon - Fri: 9:00 AM - 7:00 PM"
        },
        overviews: [
            "Snap Story specializes in capturing timeless memories with a unique perspective. Their team of skilled photographers is committed to providing you with beautiful images that reflect the spirit of your event.",
            "From intimate weddings to grand parties, Snap Story ensures that every important moment is captured in a way that tells your story."
        ],
        experience: [
            "Wedding Photography",
            "Corporate Event Photography",
            "Family and Group Portraits",
            "Photojournalistic Approach",
            "Personalized Albums"
        ],
        services: [
            "Custom Photo Packages",
            "Professional Editing",
            "Event Photography",
            "Drone Photography (for large events)",
            "High-Quality Prints and Albums"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Snap Story for my event?",
                content: "Booking Snap Story is simple. You can reach us through our website to request a quote, or give us a call to discuss your event details and schedule a consultation."
            },
            {
                id: 2,
                heading: "What is included in your photo packages?",
                content: "Our photo packages vary based on the event and your needs. Typically, they include a pre-event consultation, photography coverage, professional editing, and a photo album or online gallery."
            },
            {
                id: 3,
                heading: "Do you offer photo editing services?",
                content: "Yes, all photos are professionally edited to ensure high-quality images. We also offer custom edits based on your preferences."
            },
            {
                id: 4,
                heading: "Can I customize my photography package?",
                content: "Absolutely! We offer customized packages tailored to your specific event needs, whether you're hosting a wedding, corporate event, or family gathering."
            },
            {
                id: 5,
                heading: "Do you offer albums or prints?",
                content: "Yes, we provide high-quality photo albums and prints. You can choose from a variety of album styles and sizes, and we offer a range of print options to display your memories."
            }
        ],
        location: {
            description: "Snap Story is based in New York and serves clients across the city and beyond. Contact us to schedule a consultation or visit us to see our portfolio and learn more about how we can capture your event's special moments.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193031.85867145998!2d-74.0260168!3d40.712776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259af4d58d9a7%3A0x5665bc8c2586b925!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1727270051987!5m2!1sen!2s"
        },
        gallery: [
            images.photography1Gallery1,
            images.photography1Gallery2,
            images.photography1Gallery3,
            images.photography1Gallery4,
            images.photography1Gallery5,
            images.photography1Gallery6,
            images.photography1Gallery7,
            images.photography1Gallery8,
            images.photography1Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.photography1Review1,
                name: "Emma Roberts",
                date: "April 20, 2024",
                rating: 5,
                content: "Snap Story did an amazing job at our wedding! The photos are stunning, and they captured every precious moment beautifully. Highly recommend them!"
            },
            {
                id: 2,
                image: images.photography1Review2,
                name: "Liam Davis",
                date: "April 25, 2024",
                rating: 4.7,
                content: "The team at Snap Story is fantastic! They were so professional and captured our event perfectly. We love the final photos and would definitely hire them again."
            }
        ]
    },
    {
        id: 10,
        image: images.photography2,
        title: "Timeless Lens",
        content: "Timeless Lens specializes in capturing the unforgettable moments of your event with an artistic touch. Their photographers focus on blending traditional styles with modern techniques for stunning results.",
        details: {
            category: "Event Photography",
            phoneNumber: "(987) 654-3210",
            email: "contact@timelesslens.com",
            website: "www.timelesslens.com",
            location: "Los Angeles, CA, USA",
            priceRange: "$1,200 - $4,500",
            availability: "Available for weddings, corporate events, engagement shoots, and more",
            specialties: "Fine art photography, candid moments, portrait photography",
            businessHours: "Mon - Fri: 10:00 AM - 6:00 PM"
        },
        overviews: [
            "At Timeless Lens, we believe in capturing moments that last a lifetime. Our approach combines artistic expression with technical precision to give you photos that are as timeless as the memories they represent.",
            "Whether it's a wedding, engagement, or corporate event, our team ensures that every detail is beautifully documented."
        ],
        experience: [
            "Creative Wedding Photography",
            "Engagement and Portrait Shoots",
            "Corporate Event Coverage",
            "Professional Photo Editing",
            "Customizable Packages"
        ],
        services: [
            "Full-Day Photography Coverage",
            "Custom Albums and Prints",
            "Engagement Sessions",
            "Drone Photography for Large Events",
            "Personalized Consultation and Planning"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Timeless Lens for my event?",
                content: "You can book Timeless Lens by filling out the contact form on our website, or simply give us a call to discuss your event. We'll be happy to provide you with a quote and schedule a consultation."
            },
            {
                id: 2,
                heading: "What is included in your photography packages?",
                content: "Our packages include pre-event consultations, photography coverage, and edited images. Depending on the package, we also provide albums, prints, and additional services like drone photography."
            },
            {
                id: 3,
                heading: "Can I customize my photography package?",
                content: "Yes, we offer customizable packages to suit your needs. We’ll work with you to tailor a package that covers your desired photography sessions and any special requests."
            },
            {
                id: 4,
                heading: "Do you offer photo albums or prints?",
                content: "Yes, we offer beautiful, high-quality albums and prints. You can select from a variety of designs and sizes to preserve your memories in a way that suits your style."
            },
            {
                id: 5,
                heading: "What kind of events do you cover?",
                content: "We specialize in weddings, engagements, corporate events, and other special occasions. We also provide family portrait sessions and event coverage for various celebrations."
            }
        ],
        location: {
            description: "Timeless Lens is based in Los Angeles, and we are available for events across the region and beyond. Visit our website for a portfolio preview, or contact us to schedule a consultation and learn more about our services.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d316539.2569702097!2d-118.243683!3d34.052235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c6a0ef1c48af%3A0x654d14f3d9e4b24e!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1727270156589!5m2!1sen!2s"
        },
        gallery: [
            images.photography2Gallery1,
            images.photography2Gallery2,
            images.photography2Gallery3,
            images.photography2Gallery4,
            images.photography2Gallery5,
            images.photography2Gallery6,
            images.photography2Gallery7,
            images.photography2Gallery8,
            images.photography2Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.photography2Review1,
                name: "Sophia Adams",
                date: "May 5, 2024",
                rating: 5,
                content: "Timeless Lens did an outstanding job with our wedding photos! The photos are absolutely beautiful, and they really captured the essence of our special day. Highly recommended!"
            },
            {
                id: 2,
                image: images.photography2Review2,
                name: "Michael Clark",
                date: "May 12, 2024",
                rating: 4.8,
                content: "We couldn't be happier with the photos from Timeless Lens. The team was professional, and the photos turned out gorgeous. A great experience from start to finish!"
            }
        ]
    },
    {
        id: 11,
        image: images.photography3,
        title: "Light Frame",
        content: "Light Frame specializes in capturing life's most important moments with a unique blend of natural light photography and a creative eye, perfect for any event or personal session.",
        details: {
            category: "Event Photography",
            phoneNumber: "(123) 987-6543",
            email: "info@lightframe.com",
            website: "www.lightframe.com",
            location: "New York, NY, USA",
            priceRange: "$1,000 - $4,000",
            availability: "Available for weddings, portraits, corporate events, and private sessions",
            specialties: "Natural light photography, candid moments, personalized shoots",
            businessHours: "Mon - Fri: 9:00 AM - 5:00 PM"
        },
        overviews: [
            "At Light Frame, we focus on using the beauty of natural light to capture the most authentic moments of your event. Our photographers have an eye for detail, ensuring every shot tells a story.",
            "From weddings to corporate events, we specialize in crafting images that evoke emotion and preserve memories for a lifetime."
        ],
        experience: [
            "Natural Light Photography",
            "Creative and Personalized Shoots",
            "Engagement and Wedding Sessions",
            "Corporate Event Coverage",
            "Professional Editing and Retouching"
        ],
        services: [
            "Wedding Photography",
            "Engagement and Couple Sessions",
            "Event Photography",
            "Personalized Portraits",
            "Professional Albums and Prints"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Light Frame for my event?",
                content: "Booking is simple! Reach out to us through our website or by phone to discuss your event details. We'll help you select the best package and schedule a consultation."
            },
            {
                id: 2,
                heading: "Do you offer packages for weddings?",
                content: "Yes, we offer customizable wedding packages that include pre-event consultations, full-day coverage, and edited photos. We can tailor the package to suit your specific needs."
            },
            {
                id: 3,
                heading: "What is your pricing structure?",
                content: "Our pricing varies based on the type of event and the services you require. We offer packages starting from $1,000, and we're happy to provide a custom quote based on your needs."
            },
            {
                id: 4,
                heading: "Do you provide edited photos?",
                content: "Yes, all of our photos are professionally edited to enhance the colors, lighting, and composition, ensuring that your images are stunning and ready to cherish."
            },
            {
                id: 5,
                heading: "Can I request specific shots for my event?",
                content: "Absolutely! We encourage clients to share their vision with us. If there are particular moments or shots you'd like us to capture, we'll do our best to make them happen."
            }
        ],
        location: {
            description: "Light Frame is based in New York, NY, and available for events across the region and beyond. Visit our website to view our portfolio or contact us for more details.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241324.7543239858!2d-74.005941!3d40.712776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25c3354de2c59%3A0x3cb7db9fdce485e1!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1727270714109!5m2!1sen!2s"
        },
        gallery: [
            images.photography3Gallery1,
            images.photography3Gallery2,
            images.photography3Gallery3,
            images.photography3Gallery4,
            images.photography3Gallery5,
            images.photography3Gallery6,
            images.photography3Gallery7,
            images.photography3Gallery8,
            images.photography3Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.photography3Review1,
                name: "Emma Wilson",
                date: "April 28, 2024",
                rating: 5,
                content: "Light Frame captured our wedding day beautifully! The photos are stunning, and the team was so easy to work with. They truly captured the essence of our celebration."
            },
            {
                id: 2,
                image: images.photography3Review2,
                name: "David Johnson",
                date: "May 3, 2024",
                rating: 4.9,
                content: "The team at Light Frame did an amazing job with our engagement photos. The natural light style was exactly what we were looking for. We couldn't be happier!"
            }
        ]
    },
    {
        id: 12,
        image: images.photography4,
        title: "True Focus",
        content: "True Focus is dedicated to capturing moments with precision and clarity, offering professional event photography services for weddings, parties, and corporate events.",
        details: {
            category: "Event Photography",
            phoneNumber: "(555) 555-1234",
            email: "info@truefocus.com",
            website: "www.truefocus.com",
            location: "Los Angeles, CA, USA",
            priceRange: "$1,500 - $5,500",
            availability: "Available for weddings, corporate events, and private parties",
            specialties: "Weddings, corporate events, candid photography",
            businessHours: "Mon - Sat: 9:00 AM - 6:00 PM"
        },
        overviews: [
            "True Focus is committed to providing exceptional photography services, capturing your most precious moments with sharp attention to detail and creative insight.",
            "Whether you're celebrating a wedding, hosting a corporate event, or organizing a private party, True Focus brings a unique touch to your photography needs."
        ],
        experience: [
            "Wedding Photography",
            "Event and Party Coverage",
            "Corporate Event Photography",
            "Candid and Natural Shots",
            "Customizable Photography Packages"
        ],
        services: [
            "Full-day Event Coverage",
            "Engagement Sessions",
            "On-location Shoots",
            "Custom Photography Albums",
            "Professional Editing and Retouching"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book True Focus for my event?",
                content: "Booking True Focus is easy! Contact us through our website or call to schedule a consultation, and we will customize the perfect photography package for your event."
            },
            {
                id: 2,
                heading: "What is the pricing for your services?",
                content: "Our pricing depends on the type of event and the services required. Packages start at $1,500, and we offer custom quotes based on your needs and preferences."
            },
            {
                id: 3,
                heading: "Do you offer wedding photography packages?",
                content: "Yes, we offer comprehensive wedding packages that include pre-event consultations, full-day coverage, and edited photos. We can tailor the package to your needs."
            },
            {
                id: 4,
                heading: "Do you provide digital and printed photos?",
                content: "Yes, we offer both digital copies and printed albums. You can choose the format that works best for you and your event."
            },
            {
                id: 5,
                heading: "Can I request specific shots for my event?",
                content: "Of course! We encourage you to share any specific requests or ideas with us. Our team will ensure that those moments are captured just as you envisioned."
            }
        ],
        location: {
            description: "Located in Los Angeles, CA, True Focus offers event photography services for clients across the area. Visit our website or contact us for a personalized consultation.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d331763.64810543296!2d-118.243684!3d34.052235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c7b4c0c0d459%3A0x1a587d2a3f4699f5!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1727272274109!5m2!1sen!2s"
        },
        gallery: [
            images.photography4Gallery1,
            images.photography4Gallery2,
            images.photography4Gallery3,
            images.photography4Gallery4,
            images.photography4Gallery5,
            images.photography4Gallery6,
            images.photography4Gallery7,
            images.photography4Gallery8,
            images.photography4Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.photography4Review1,
                name: "Olivia Green",
                date: "April 22, 2024",
                rating: 5,
                content: "True Focus made our wedding day unforgettable! Their attention to detail and ability to capture every moment perfectly was beyond our expectations."
            },
            {
                id: 2,
                image: images.photography4Review2,
                name: "Ethan Clark",
                date: "May 6, 2024",
                rating: 4.8,
                content: "We had an amazing experience with True Focus. The photos were stunning, and the team made sure to capture every special moment at our event."
            }
        ]
    },
    {
        id: 13,
        image: images.venue1,
        title: "Garden Hall",
        content: "Garden Hall offers an enchanting wedding venue, surrounded by lush gardens, creating a picturesque setting for your dream wedding day.",
        details: {
            category: "Wedding Venues",
            phoneNumber: "(555) 678-9101",
            email: "info@gardenhall.com",
            website: "www.gardenhall.com",
            location: "Springfield, IL, USA",
            priceRange: "$5,000 - $15,000",
            availability: "Available for weddings, receptions, and private events",
            specialties: "Outdoor ceremonies, garden receptions, exclusive venue space",
            businessHours: "Mon - Fri: 9:00 AM - 5:00 PM"
        },
        overviews: [
            "Garden Hall is a unique wedding venue that blends nature's beauty with exceptional service. From your outdoor ceremony to your elegant reception, we ensure every detail is perfect.",
            "Let Garden Hall be the backdrop of your love story. Our venue provides a serene garden setting and first-class amenities to make your wedding day unforgettable."
        ],
        experience: [
            "Outdoor Wedding Ceremonies",
            "Elegant Garden Receptions",
            "Exclusive Use of Venue",
            "Customizable Event Packages",
            "Professional Event Coordination"
        ],
        services: [
            "Venue Space for Ceremonies and Receptions",
            "Event Planning and Coordination",
            "Floral and Décor Options",
            "Catering and Bar Services",
            "On-Site Wedding Coordination"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Garden Hall for my wedding?",
                content: "Booking Garden Hall is simple! Visit our website, fill out the contact form, or call us to schedule a tour and discuss your wedding details."
            },
            {
                id: 2,
                heading: "What is the pricing for your venue?",
                content: "Our venue pricing starts at $5,000, with customizable packages depending on the event's size and the services required. Contact us for a personalized quote."
            },
            {
                id: 3,
                heading: "Can I bring my own vendors?",
                content: "Yes, you are welcome to bring your own vendors. However, we also offer a list of preferred vendors to make planning easier for you."
            },
            {
                id: 4,
                heading: "What types of events do you host?",
                content: "We specialize in weddings, receptions, and private parties. We also host corporate events, charity galas, and intimate gatherings."
            },
            {
                id: 5,
                heading: "Is Garden Hall accessible for guests with disabilities?",
                content: "Yes, Garden Hall is fully accessible. We are committed to making sure all guests have a comfortable and enjoyable experience."
            }
        ],
        location: {
            description: "Garden Hall is nestled in the heart of Springfield, offering stunning views and a tranquil environment for your event. Visit us for a tour and see why it's the perfect venue for your wedding.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d252896.70412465034!2d-89.65039217843147!3d39.78172130103325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88750857d60e5ebf%3A0x634bb1320cd7cba2!2sSpringfield%2C%20IL%2C%20USA!5e0!3m2!1sen!2s!4v1727272275415!5m2!1sen!2s"
        },
        gallery: [
            images.venue1Gallery1,
            images.venue1Gallery2,
            images.venue1Gallery3,
            images.venue1Gallery4,
            images.venue1Gallery5,
            images.venue1Gallery6,
            images.venue1Gallery7,
            images.venue1Gallery8,
            images.venue1Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.venue1Review1,
                name: "Anna Stevens",
                date: "March 10, 2024",
                rating: 5,
                content: "Garden Hall was the perfect venue for our wedding. The gardens were breathtaking, and the team made everything seamless and stress-free."
            },
            {
                id: 2,
                image: images.venue1Review2,
                name: "David Brooks",
                date: "April 1, 2024",
                rating: 4.8,
                content: "Our wedding at Garden Hall was unforgettable. The outdoor ceremony space was stunning, and our guests were wowed by the beautiful setting."
            }
        ]
    },
    {
        id: 14,
        image: images.venue2,
        title: "Pine Estate",
        content: "Pine Estate offers an elegant and secluded venue surrounded by lush pine trees, providing a tranquil and intimate setting for your special day.",
        details: {
            category: "Wedding Venues",
            phoneNumber: "(555) 234-5678",
            email: "contact@pineestate.com",
            website: "www.pineestate.com",
            location: "Aspen Hills, CO, USA",
            priceRange: "$8,000 - $20,000",
            availability: "Available for weddings, receptions, and private events",
            specialties: "Rustic elegance, outdoor ceremonies, exclusive venue access",
            businessHours: "Mon - Fri: 9:00 AM - 5:00 PM"
        },
        overviews: [
            "Pine Estate is an idyllic wedding venue located in the heart of Aspen Hills, providing a serene backdrop of towering pine trees and elegant outdoor spaces for your ceremony and reception.",
            "With its rustic charm and natural beauty, Pine Estate offers an unforgettable experience for couples seeking an intimate, nature-filled wedding."
        ],
        experience: [
            "Rustic Outdoor Wedding Ceremonies",
            "Secluded and Exclusive Venue",
            "Customizable Event Packages",
            "Scenic Reception Settings",
            "On-site Event Coordination"
        ],
        services: [
            "Venue Space for Outdoor Ceremonies and Receptions",
            "Floral and Décor Services",
            "Catering and Bar Services",
            "Event Planning and Coordination",
            "Bridal Suite and Groom’s Room"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Pine Estate for my wedding?",
                content: "Booking Pine Estate is simple! Visit our website or give us a call to schedule a tour and discuss your wedding plans. We will help you with every detail."
            },
            {
                id: 2,
                heading: "What is the venue pricing?",
                content: "Our pricing ranges from $8,000 to $20,000 depending on the season and package chosen. Contact us for a detailed quote."
            },
            {
                id: 3,
                heading: "Do you offer exclusive access to the venue?",
                content: "Yes, Pine Estate offers exclusive access for your wedding day, ensuring that your event is private and personalized to your desires."
            },
            {
                id: 4,
                heading: "Can I customize my event package?",
                content: "Absolutely! We offer flexible packages tailored to your needs, whether it's a grand reception or an intimate gathering."
            },
            {
                id: 5,
                heading: "Are there any restrictions for outdoor ceremonies?",
                content: "Pine Estate provides a beautiful outdoor space for ceremonies, but weather conditions may affect availability. We recommend having a backup plan in case of inclement weather."
            }
        ],
        location: {
            description: "Pine Estate is nestled in the tranquil beauty of Aspen Hills, offering a peaceful and secluded setting for your wedding. Visit us for a personal tour and see why Pine Estate is the perfect venue for your special day.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317745.0611742971!2d-106.845746318555!3d39.64851067106206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b6358b02f42c7%3A0xa4b7039051ad383a!2sAspen%20Hills%2C%20CO%2C%20USA!5e0!3m2!1sen!2s!4v1727280385954!5m2!1sen!2s"
        },
        gallery: [
            images.venue2Gallery1,
            images.venue2Gallery2,
            images.venue2Gallery3,
            images.venue2Gallery4,
            images.venue2Gallery5,
            images.venue2Gallery6,
            images.venue2Gallery7,
            images.venue2Gallery8,
            images.venue2Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.venue2Review1,
                name: "Jessica Davis",
                date: "March 15, 2024",
                rating: 5,
                content: "Pine Estate was the perfect venue for our wedding! The scenic beauty of the pine trees and the peaceful environment made our special day truly magical."
            },
            {
                id: 2,
                image: images.venue2Review2,
                name: "Michael Green",
                date: "April 3, 2024",
                rating: 4.9,
                content: "Our wedding at Pine Estate was unforgettable. The venue was stunning, and the staff made everything so easy. Highly recommend it to anyone looking for a beautiful, rustic venue."
            }
        ]
    },
    {
        id: 15,
        image: images.venue3,
        title: "Rose Manor",
        content: "Rose Manor is a timeless wedding venue offering a blend of classic elegance and romantic charm, featuring stunning gardens and a grand hall for your celebration.",
        details: {
            category: "Wedding Venues",
            phoneNumber: "(555) 345-6789",
            email: "info@rosemanor.com",
            website: "www.rosemanor.com",
            location: "Rosewood Lane, 123 Blossom Avenue, Roseville, CA",
            priceRange: "$10,000 - $25,000",
            availability: "Available for weddings, receptions, and special events",
            specialties: "Grand ballroom, garden ceremonies, luxurious indoor and outdoor settings",
            businessHours: "Mon - Fri: 9:00 AM - 6:00 PM"
        },
        overviews: [
            "Rose Manor is a refined and romantic venue in the heart of Roseville, offering both grand indoor ballrooms and exquisite outdoor garden spaces perfect for weddings and other special events.",
            "With its combination of classic architecture, modern amenities, and breathtaking views, Rose Manor provides an unforgettable backdrop for your celebration."
        ],
        experience: [
            "Elegant Garden Ceremonies",
            "Grand Ballroom for Receptions",
            "Luxury Bridal Suite",
            "On-site Catering and Bar Services",
            "Experienced Event Coordination"
        ],
        services: [
            "Exclusive Venue for Weddings and Events",
            "Personalized Wedding Packages",
            "Full-Service Catering and Drinks",
            "Floral and Event Design Services",
            "On-site Wedding Planner"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book a tour of Rose Manor?",
                content: "Booking a tour is easy! Visit our website to schedule a tour or contact our team to arrange a personalized visit to see our venue."
            },
            {
                id: 2,
                heading: "What is the pricing for hosting an event at Rose Manor?",
                content: "Prices range from $10,000 to $25,000 depending on the type of event, the season, and the services included. Please contact us for a customized quote."
            },
            {
                id: 3,
                heading: "Do you offer wedding planning services?",
                content: "Yes, we offer full-service wedding planning to ensure every detail of your big day is perfectly coordinated."
            },
            {
                id: 4,
                heading: "What types of ceremonies can I have at Rose Manor?",
                content: "You can choose between a beautiful garden ceremony or an elegant indoor ceremony in our grand ballroom, depending on your preferences and the season."
            },
            {
                id: 5,
                heading: "Can we host our reception outdoors?",
                content: "Absolutely! Rose Manor offers stunning outdoor reception options with views of our gardens, ideal for creating a magical atmosphere."
            }
        ],
        location: {
            description: "Rose Manor is located in the charming town of Roseville, CA, offering a blend of modern luxury and traditional elegance. Visit us to explore the venue and discover how we can make your special day extraordinary.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sRoseville%2C%20CA!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.venue3Gallery1,
            images.venue3Gallery2,
            images.venue3Gallery3,
            images.venue3Gallery4,
            images.venue3Gallery5,
            images.venue3Gallery6,
            images.venue3Gallery7,
            images.venue3Gallery8,
            images.venue3Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.venue3Review1,
                name: "Lily Thompson",
                date: "March 20, 2024",
                rating: 5,
                content: "Rose Manor was the perfect venue for our wedding! The gardens were breathtaking, and the ballroom provided a beautiful space for our reception. We couldn’t have asked for a better venue!"
            },
            {
                id: 2,
                image: images.venue3Review2,
                name: "Robert Williams",
                date: "April 1, 2024",
                rating: 4.8,
                content: "Our wedding at Rose Manor was a dream come true. The team was so helpful throughout the entire process, and the venue itself is stunning. Highly recommend for anyone looking for a luxurious venue."
            }
        ]
    },
    {
        id: 16,
        image: images.venue4,
        title: "Crystal Venue",
        content: "Crystal Venue offers a glamorous and elegant setting for weddings and events, featuring crystal chandeliers, modern amenities, and exceptional service for an unforgettable experience.",
        details: {
            category: "Wedding Venues",
            phoneNumber: "(555) 456-7890",
            email: "info@crystalvenue.com",
            website: "www.crystalvenue.com",
            location: "Crystal Bay Road, 789 Diamond Street, Crystal City, NY",
            priceRange: "$12,000 - $30,000",
            availability: "Available for weddings, receptions, galas, and corporate events",
            specialties: "Crystal chandeliers, luxurious ballroom, scenic outdoor patio",
            businessHours: "Mon - Fri: 9:00 AM - 6:00 PM"
        },
        overviews: [
            "Crystal Venue is the epitome of elegance, with its stunning crystal chandeliers and modern amenities, creating the perfect backdrop for your wedding or special event.",
            "Our grand ballroom and scenic outdoor patio provide versatile settings for both indoor and outdoor events, ensuring a memorable experience for you and your guests."
        ],
        experience: [
            "Glamorous Crystal Chandeliers",
            "Spacious Ballroom for Receptions",
            "Outdoor Patio with Scenic Views",
            "On-site Catering and Bar Services",
            "Experienced Event Management Team"
        ],
        services: [
            "Exclusive Venue for Weddings and Events",
            "Customized Wedding Packages",
            "Full-Service Catering and Drinks",
            "Event Planning and Coordination",
            "On-site Decor and Floral Services"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book a tour of Crystal Venue?",
                content: "Booking a tour is simple! Visit our website or give us a call to schedule a personal tour and explore our venue."
            },
            {
                id: 2,
                heading: "What is the price range for booking an event?",
                content: "Pricing ranges from $12,000 to $30,000 depending on the type of event, services included, and season. Contact us for a customized quote."
            },
            {
                id: 3,
                heading: "Do you offer event planning services?",
                content: "Yes, we offer full-service event planning to help coordinate every aspect of your event, from decor to catering."
            },
            {
                id: 4,
                heading: "Can we hold our wedding outdoors?",
                content: "Yes, Crystal Venue offers a beautiful outdoor patio where you can host your ceremony or reception with breathtaking views."
            },
            {
                id: 5,
                heading: "Do you provide catering services?",
                content: "Yes, we offer a wide range of catering options to suit your tastes, from plated meals to buffet-style dining, all prepared by our expert chefs."
            }
        ],
        location: {
            description: "Located in the heart of Crystal City, NY, Crystal Venue is the perfect place for a lavish wedding or event. Visit us for a personal tour, and let us help you plan your dream celebration.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sCrystal%20City%2C%20NY!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.venue4Gallery1,
            images.venue4Gallery2,
            images.venue4Gallery3,
            images.venue4Gallery4,
            images.venue4Gallery5,
            images.venue4Gallery6,
            images.venue4Gallery7,
            images.venue4Gallery8,
            images.venue4Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.venue4Review1,
                name: "Olivia Clark",
                date: "May 10, 2024",
                rating: 5,
                content: "Our wedding at Crystal Venue was absolutely perfect! The chandeliers were stunning, and the service was top-notch. Everything went smoothly, and our guests had a fantastic time!"
            },
            {
                id: 2,
                image: images.venue4Review2,
                name: "Ethan Scott",
                date: "May 15, 2024",
                rating: 4.8,
                content: "Crystal Venue exceeded our expectations. The venue is elegant and spacious, and the outdoor patio made for the most beautiful ceremony. Highly recommend!"
            }
        ]
    },
    {
        id: 17,
        image: images.attire1,
        title: "Gown House",
        content: "Gown House offers a wide selection of exquisite bridal attire, featuring stunning wedding gowns, bridesmaid dresses, and accessories tailored to make your special day unforgettable.",
        details: {
            category: "Bridal Attire",
            phoneNumber: "(555) 789-0123",
            email: "info@gownhouse.com",
            website: "www.gownhouse.com",
            location: "Bridal Avenue, 321 Royal Street, New York, NY",
            priceRange: "$1,500 - $4,000",
            availability: "Available for custom fittings, consultations, and wedding dress rentals",
            specialties: "Custom wedding gowns, bridesmaid dresses, wedding accessories",
            businessHours: "Mon - Fri: 10:00 AM - 7:00 PM"
        },
        overviews: [
            "At Gown House, we believe every bride deserves to feel like royalty. Our collection features a wide array of wedding gowns, from classic to modern styles, designed to flatter every body type.",
            "From custom fittings to accessory selection, our expert team ensures you find the perfect gown that reflects your style and vision for your wedding day."
        ],
        experience: [
            "Custom Wedding Gown Design",
            "Bridal Party Dress Coordination",
            "Expert Style Consultations",
            "On-site Alterations and Fittings",
            "Wedding Accessory Selection"
        ],
        services: [
            "Exclusive Bridal Gown Selection",
            "Bridesmaid Dresses and Accessories",
            "Custom Gown Fittings and Alterations",
            "Wedding Dress Rentals",
            "Personalized Bridal Consultations"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book an appointment at Gown House?",
                content: "Booking an appointment is easy! Simply visit our website or call us to schedule a personalized consultation and fitting."
            },
            {
                id: 2,
                heading: "What is the price range for wedding gowns?",
                content: "Our wedding gowns range from $1,500 to $4,000, depending on the style, materials, and customization options. Contact us for a more detailed quote."
            },
            {
                id: 3,
                heading: "Do you offer wedding dress rentals?",
                content: "Yes, we offer wedding dress rentals for brides who prefer a more affordable option. We have a variety of styles available for rental."
            },
            {
                id: 4,
                heading: "How far in advance should I order my gown?",
                content: "We recommend ordering your gown at least 6 months in advance to allow for fittings, alterations, and delivery."
            },
            {
                id: 5,
                heading: "Do you provide alterations for the wedding gowns?",
                content: "Yes, we offer on-site alterations to ensure your gown fits perfectly. Our expert seamstresses will make any necessary adjustments for the perfect fit."
            }
        ],
        location: {
            description: "Visit Gown House to explore our wide selection of wedding gowns and bridal attire. Our experienced consultants will guide you through every step of the process, from choosing the right gown to ensuring the perfect fit.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sGown%20House%2C%20New%20York%2C%20NY!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.attire1Gallery1,
            images.attire1Gallery2,
            images.attire1Gallery3,
            images.attire1Gallery4,
            images.attire1Gallery5,
            images.attire1Gallery6,
            images.attire1Gallery7,
            images.attire1Gallery8,
            images.attire1Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.attire1Review1,
                name: "Emily Roberts",
                date: "May 20, 2024",
                rating: 5,
                content: "Gown House made my bridal experience unforgettable! Their selection was amazing, and the fitting process was so personalized. I felt like a queen on my wedding day!"
            },
            {
                id: 2,
                image: images.attire1Review2,
                name: "Sophie Wright",
                date: "May 22, 2024",
                rating: 4.8,
                content: "I found the perfect wedding gown at Gown House! The staff were incredibly helpful, and I loved the custom fitting experience. Highly recommend!"
            }
        ]
    },
    {
        id: 18,
        image: images.attire2,
        title: "Veil Room",
        content: "Veil Room offers an exclusive collection of bridal veils, headpieces, and accessories that complete your wedding day look with elegance and sophistication.",
        details: {
            category: "Bridal Attire",
            phoneNumber: "(555) 890-1234",
            email: "info@veilroom.com",
            website: "www.veilroom.com",
            location: "Accessory Lane, Bridal Boulevard, Los Angeles, CA",
            priceRange: "$200 - $2,500",
            availability: "Available for custom veil fittings, consultations, and bridal accessory rentals",
            specialties: "Custom veils, headpieces, bridal jewelry",
            businessHours: "Mon - Sat: 10:00 AM - 6:00 PM"
        },
        overviews: [
            "At Veil Room, we specialize in creating bespoke bridal accessories, from timeless veils to delicate headpieces, designed to complement your wedding gown and make you feel truly special.",
            "Whether you're looking for a classic veil or a unique, custom design, our expert consultants are here to help you find the perfect piece for your wedding day."
        ],
        experience: [
            "Custom Bridal Veil Design",
            "Personalized Headpiece Selection",
            "Exclusive Bridal Accessories",
            "On-site Consultations and Fittings",
            "Attention to Detail and Craftsmanship"
        ],
        services: [
            "Custom Bridal Veil Design",
            "Bridal Headpieces and Jewelry",
            "Veil Rentals for Brides",
            "Personalized Bridal Consultations",
            "On-site Fittings and Alterations"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I schedule a consultation at Veil Room?",
                content: "Scheduling a consultation is easy! Simply visit our website or give us a call to book a personalized appointment with one of our expert consultants."
            },
            {
                id: 2,
                heading: "What is the price range for bridal veils?",
                content: "Our bridal veils range from $200 to $2,500 depending on the style, materials, and customization options. We offer a variety of price points to suit every bride's needs."
            },
            {
                id: 3,
                heading: "Do you offer veil rentals?",
                content: "Yes, we offer bridal veil rentals for brides looking for an affordable option. Contact us to learn more about our rental collection."
            },
            {
                id: 4,
                heading: "When should I order my bridal veil?",
                content: "We recommend ordering your veil at least 4 to 6 months in advance to ensure we have enough time for any customizations and fittings."
            },
            {
                id: 5,
                heading: "Do you offer on-site fittings for bridal veils?",
                content: "Yes, we provide on-site fittings to ensure your veil complements your gown perfectly. Our consultants will guide you through the fitting process."
            }
        ],
        location: {
            description: "Visit Veil Room to discover the perfect bridal accessories that will complete your wedding day look. Our expert consultants are ready to help you find a veil that matches your gown and personal style.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sVeil%20Room%2C%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.attire2Gallery1,
            images.attire2Gallery2,
            images.attire2Gallery3,
            images.attire2Gallery4,
            images.attire2Gallery5,
            images.attire2Gallery6,
            images.attire2Gallery7,
            images.attire2Gallery8,
            images.attire2Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.attire1Review1,
                name: "Olivia Turner",
                date: "June 5, 2024",
                rating: 5,
                content: "I found the perfect veil at Veil Room! The selection was amazing, and the staff was so helpful. They truly made the process stress-free, and I felt beautiful on my wedding day."
            },
            {
                id: 2,
                image: images.attire1Review2,
                name: "Isabella Green",
                date: "June 10, 2024",
                rating: 4.9,
                content: "Veil Room helped me choose the most elegant veil to match my dress. The custom design service was fantastic, and they made sure everything fit perfectly."
            }
        ]
    },
    {
        id: 19,
        image: images.attire3,
        title: "Bridal Loft",
        content: "Bridal Loft offers a wide selection of stunning bridal gowns and accessories, designed to make every bride feel glamorous on her wedding day.",
        details: {
            category: "Bridal Attire",
            phoneNumber: "(555) 678-9012",
            email: "info@bridalloft.com",
            website: "www.bridalloft.com",
            location: "Gown Avenue, 450 Bridal Street, New York, NY",
            priceRange: "$1,000 - $8,000",
            availability: "Available for bridal gown fittings, custom designs, and bridal accessory consultations",
            specialties: "Wedding gowns, custom bridal dresses, veils, bridal jewelry",
            businessHours: "Mon - Sat: 9:00 AM - 7:00 PM"
        },
        overviews: [
            "At Bridal Loft, we offer an extensive collection of bridal gowns and accessories designed to make you feel confident and beautiful on your wedding day. Whether you're looking for something classic or modern, we have something for every bride.",
            "Our team of experts is dedicated to finding the perfect gown that reflects your unique style and personality, ensuring you feel like the best version of yourself on your wedding day."
        ],
        experience: [
            "Custom Bridal Gown Design",
            "Personalized Fitting and Alterations",
            "Exclusive Bridal Accessories",
            "Expert Bridal Consultation",
            "Elegant and Comfortable Gowns"
        ],
        services: [
            "Bridal Gown Rentals and Sales",
            "Custom Bridal Gown Design",
            "Bridal Accessory Selection",
            "Bridal Gown Fittings and Alterations",
            "On-site Consultations"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I schedule a fitting at Bridal Loft?",
                content: "To schedule a fitting, simply contact us through our website or give us a call. Our team will assist you in choosing the best time for your appointment."
            },
            {
                id: 2,
                heading: "What is the price range for bridal gowns?",
                content: "Our bridal gowns range from $1,000 to $8,000, depending on the design, fabric, and customization options. We offer gowns for every budget and style."
            },
            {
                id: 3,
                heading: "Do you offer custom bridal gown designs?",
                content: "Yes, we specialize in custom bridal gown designs. Our expert designers will work with you to create the gown of your dreams, tailored to your exact specifications."
            },
            {
                id: 4,
                heading: "How early should I order my bridal gown?",
                content: "We recommend ordering your gown at least 6 months before your wedding date to allow for design, production, and any necessary alterations."
            },
            {
                id: 5,
                heading: "Do you provide bridal gown alterations?",
                content: "Yes, we offer bridal gown alterations to ensure your dress fits perfectly on your special day. Alterations are included in our fitting services."
            }
        ],
        location: {
            description: "Visit Bridal Loft to find the bridal gown of your dreams. Our boutique offers an extensive collection of stunning dresses, veils, and accessories, with personalized consultations to help you find the perfect look for your wedding day.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sVeil%20Room%2C%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.attire3Gallery1,
            images.attire3Gallery2,
            images.attire3Gallery3,
            images.attire3Gallery4,
            images.attire3Gallery5,
            images.attire3Gallery6,
            images.attire3Gallery7,
            images.attire3Gallery8,
            images.attire3Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.attire1Review1,
                name: "Charlotte Brooks",
                date: "May 10, 2024",
                rating: 5,
                content: "I had the most wonderful experience at Bridal Loft! They helped me find my dream gown, and the alterations were flawless. I felt beautiful on my wedding day."
            },
            {
                id: 2,
                image: images.attire1Review2,
                name: "Sophia Harris",
                date: "May 15, 2024",
                rating: 4.8,
                content: "Bridal Loft has an incredible selection of gowns! The staff was friendly and professional, and they made the whole process so enjoyable. Highly recommend!"
            }
        ]
    },
    {
        id: 20,
        image: images.attire4,
        title: "Lace Studio",
        content: "Lace Studio is known for its exquisite bridal gowns and intricate lace designs, offering brides the perfect balance of elegance and modern sophistication.",
        details: {
            category: "Bridal Attire",
            phoneNumber: "(555) 789-0123",
            email: "info@lacestudio.com",
            website: "www.lacestudio.com",
            location: "Lace Avenue, 320 Bridal Lane, Chicago, IL",
            priceRange: "$1,500 - $6,000",
            availability: "Available for bridal fittings, custom gown design, and lace detailing consultations",
            specialties: "Lace bridal gowns, custom designs, bridal accessories, detailed embroidery",
            businessHours: "Mon - Sat: 10:00 AM - 6:00 PM"
        },
        overviews: [
            "At Lace Studio, we specialize in creating stunning bridal gowns with intricate lace detailing that adds a touch of timeless elegance to every bride’s wedding day. Our gowns are designed with attention to detail and craftsmanship, ensuring the perfect fit and a look that is both classic and modern.",
            "From lace wedding dresses to custom designs, Lace Studio is dedicated to providing brides with exceptional service and exquisite gowns for their special day."
        ],
        experience: [
            "Custom Lace Bridal Gowns",
            "Personalized Bridal Fittings",
            "Intricate Lace Detailing and Embroidery",
            "Expert Bridal Consultation",
            "Timeless and Elegant Designs"
        ],
        services: [
            "Lace Bridal Gown Design and Sales",
            "Custom Lace Detailing for Dresses",
            "Bridal Fitting and Alteration Services",
            "Exclusive Bridal Accessories",
            "Bridal Gown Preservation"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book a consultation at Lace Studio?",
                content: "Booking a consultation is easy! Simply visit our website to schedule an appointment or contact us by phone. Our team will be happy to assist you in finding the perfect gown."
            },
            {
                id: 2,
                heading: "What is the price range for your gowns?",
                content: "Our bridal gowns range from $1,500 to $6,000, depending on the design and materials used. We offer a variety of options to suit every bride’s budget and style."
            },
            {
                id: 3,
                heading: "Can I customize my bridal gown?",
                content: "Yes, we specialize in custom bridal gowns. Our team will work closely with you to create a gown that perfectly reflects your personal style, with intricate lace and embroidery details."
            },
            {
                id: 4,
                heading: "How long does it take to make a custom gown?",
                content: "Custom gowns typically take 4 to 6 months to create, depending on the complexity of the design. We recommend starting the process as early as possible to ensure timely delivery."
            },
            {
                id: 5,
                heading: "Do you offer bridal gown alterations?",
                content: "Yes, we offer professional bridal gown alterations to ensure your dress fits perfectly. Our team of experts will work with you to make any adjustments necessary for the ideal fit."
            }
        ],
        location: {
            description: "Lace Studio offers an exclusive collection of bridal gowns with intricate lace designs. Visit us to explore our stunning range of dresses and receive personalized advice from our expert team to help you find the perfect gown for your wedding day.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sVeil%20Room%2C%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.attire4Gallery1,
            images.attire4Gallery2,
            images.attire4Gallery3,
            images.attire4Gallery4,
            images.attire4Gallery5,
            images.attire4Gallery6,
            images.attire4Gallery7,
            images.attire4Gallery8,
            images.attire4Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.attire4Review1,
                name: "Emily White",
                date: "May 25, 2024",
                rating: 5,
                content: "Lace Studio made my wedding day so special! The lace detailing on my gown was absolutely stunning, and the team was so accommodating during fittings."
            },
            {
                id: 2,
                image: images.attire4Review2,
                name: "Olivia Clark",
                date: "June 1, 2024",
                rating: 4.9,
                content: "I couldn’t be happier with my dress from Lace Studio! The lace and embroidery were exactly what I envisioned. The team made the whole experience smooth and enjoyable."
            }
        ]
    },
    {
        id: 21,
        image: images.entertainment1,
        title: "Rhythm Crew",
        content: "Rhythm Crew is a top-tier music entertainment group, providing live performances and DJ services that bring energy and excitement to any event.",
        details: {
            category: "Music Entertainment",
            phoneNumber: "(555) 321-6548",
            email: "info@rhythmcrew.com",
            website: "www.rhythmcrew.com",
            location: "Groove Avenue, 555 Beat Street, New York, NY",
            priceRange: "$1,000 - $10,000",
            availability: "Available for weddings, corporate events, private parties, and more",
            specialties: "Live performances, DJ services, event entertainment, music coordination",
            businessHours: "Mon - Sun: 9:00 AM - 11:00 PM"
        },
        overviews: [
            "Rhythm Crew delivers high-energy performances that guarantee to get the crowd dancing. From live bands to DJ sets, we provide the ultimate music entertainment to make your event unforgettable.",
            "Our team of talented musicians and DJs specialize in creating the perfect soundtrack for your celebration, whether it's a wedding, corporate event, or private party."
        ],
        experience: [
            "Live Music Performances",
            "Expert DJ Services",
            "Customizable Setlists",
            "Professional Event Coordination",
            "Extensive Music Library"
        ],
        services: [
            "Live Band Performances",
            "DJ Services",
            "Event Music Coordination",
            "Custom Playlists",
            "Sound System Setup"
        ],
        faqs: [
            {
                id: 1,
                heading: "How do I book Rhythm Crew for my event?",
                content: "Booking Rhythm Crew is easy! Visit our website to request a quote or contact us directly by phone or email. We'll work with you to tailor our services to your event."
            },
            {
                id: 2,
                heading: "What types of events do you cover?",
                content: "We provide entertainment for all types of events, including weddings, corporate events, private parties, and more. Our team is experienced in adapting to the atmosphere of any occasion."
            },
            {
                id: 3,
                heading: "Do you offer different types of music styles?",
                content: "Yes! Our musicians and DJs are skilled in a wide range of genres, from jazz and classical to pop, rock, and contemporary hits. We tailor our music selection to your event’s needs."
            },
            {
                id: 4,
                heading: "What is the pricing for your services?",
                content: "Our pricing varies depending on the type of service, event duration, and location. We offer flexible packages that can be customized to suit your event and budget."
            },
            {
                id: 5,
                heading: "Do you provide sound and lighting equipment?",
                content: "Yes, we provide professional sound and lighting equipment to ensure your event has the best possible atmosphere. We also offer setup and breakdown services for your convenience."
            }
        ],
        location: {
            description: "Rhythm Crew is your go-to source for high-energy music entertainment. We are based in New York but offer services across the country. Our team is ready to bring the party to your next event.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sRhythm%20Crew%2C%20New%20York%2C%20NY!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.entertainment1Gallery1,
            images.entertainment1Gallery2,
            images.entertainment1Gallery3,
            images.entertainment1Gallery4,
            images.entertainment1Gallery5,
            images.entertainment1Gallery6,
            images.entertainment1Gallery7,
            images.entertainment1Gallery8,
            images.entertainment1Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.entertainment1Review1,
                name: "John Davis",
                date: "March 30, 2024",
                rating: 5,
                content: "Rhythm Crew made our wedding reception unforgettable! The music was perfect, and everyone was dancing all night. Highly recommend their services!"
            },
            {
                id: 2,
                image: images.entertainment1Review2,
                name: "Emma Johnson",
                date: "April 5, 2024",
                rating: 4.8,
                content: "The live band was fantastic! They played all the right songs for our corporate event. Rhythm Crew is professional, talented, and a joy to work with."
            }
        ]
    },
    {
        id: 22,
        image: images.entertainment2,
        title: "Sound Beats",
        content: "Sound Beats offers exceptional music entertainment with a mix of live performances and DJ sets to bring the right rhythm and energy to your event.",
        details: {
            category: "Music Entertainment",
            phoneNumber: "(555) 987-6543",
            email: "info@soundbeats.com",
            website: "www.soundbeats.com",
            location: "Vibe Street, 123 Rhythm Road, Los Angeles, CA",
            priceRange: "$1,500 - $12000",
            availability: "Available for weddings, corporate events, private parties, and more",
            specialties: "Live performances, DJ services, event entertainment, music coordination",
            businessHours: "Mon - Sun: 10:00 AM - 10:00 PM"
        },
        overviews: [
            "Sound Beats delivers vibrant and electrifying music entertainment, from high-energy live band performances to seamless DJ sets, ensuring your event is the highlight of the year.",
            "Our talented team will work with you to customize the perfect soundtrack for your event, making it one to remember."
        ],
        experience: [
            "Live Music Performances",
            "Professional DJ Services",
            "Tailored Event Music",
            "Wide Genre Range",
            "Event Setup & Coordination"
        ],
        services: [
            "Live Band Performances",
            "DJ Services",
            "Event Music Coordination",
            "Custom Playlists",
            "Sound & Lighting Setup"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book Sound Beats for my event?",
                content: "Booking Sound Beats is simple! Visit our website or contact us directly via phone or email. We'll guide you through the process and discuss your event needs."
            },
            {
                id: 2,
                heading: "Do you cater to all types of events?",
                content: "Yes! We specialize in events like weddings, corporate gatherings, private parties, and more. We adjust our performances to match the atmosphere of your event."
            },
            {
                id: 3,
                heading: "Can I customize the playlist for my event?",
                content: "Absolutely! We work with you to curate a playlist that aligns with your event theme and personal taste, ensuring the perfect atmosphere for your guests."
            },
            {
                id: 4,
                heading: "What are your rates for services?",
                content: "Our rates depend on the type of service, event duration, and location. We offer various packages that can be tailored to meet your specific needs."
            },
            {
                id: 5,
                heading: "Do you provide the necessary equipment?",
                content: "Yes, we supply high-quality sound and lighting equipment, and we also handle the setup and breakdown for a seamless event experience."
            }
        ],
        location: {
            description: "Located in Los Angeles, Sound Beats is ready to provide exceptional music entertainment for your event. Whether you're planning a wedding, corporate event, or private party, our team will make it unforgettable.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-118.48503913710324!3d39.78512943132194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784a45c5d08c739%3A0x4d3dfbd56b29b5eb!2sSound%20Beats%2C%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.entertainment2Gallery1,
            images.entertainment2Gallery2,
            images.entertainment2Gallery3,
            images.entertainment2Gallery4,
            images.entertainment2Gallery5,
            images.entertainment2Gallery6,
            images.entertainment2Gallery7,
            images.entertainment2Gallery8,
            images.entertainment2Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.entertainment2Review1,
                name: "Sophia Lee",
                date: "May 2, 2024",
                rating: 5,
                content: "Sound Beats made our wedding reception unforgettable! The music was perfect, and everyone was on their feet dancing all night. A huge thank you to the team!"
            },
            {
                id: 2,
                image: images.entertainment2Review2,
                name: "Michael Carter",
                date: "April 25, 2024",
                rating: 4.8,
                content: "Amazing performance at our corporate event! The DJs were fantastic and tailored the music to our crowd. Highly recommend Sound Beats for any event."
            }
        ]
    },
    {
        id: 23,
        image: images.entertainment3,
        title: "Echo Band",
        content: "Echo Band offers high-energy live music performances with a focus on classic hits and modern tunes, perfect for weddings, corporate events, and private parties.",
        details: {
            category: "Music Entertainment",
            phoneNumber: "(555) 321-9876",
            email: "info@echoband.com",
            website: "www.echoband.com",
            location: "Harmony Lane, 789 Melody Blvd, New York, NY",
            priceRange: "$2,000 - $15,000",
            availability: "Available for weddings, corporate events, private parties, and more",
            specialties: "Live band performances, genre variety, custom event music",
            businessHours: "Mon - Sun: 9:00 AM - 9:00 PM"
        },
        overviews: [
            "Echo Band brings the perfect mix of classic and contemporary hits, creating a vibrant atmosphere at any event. Our professional musicians deliver live performances that keep your guests dancing all night long.",
            "From weddings to corporate parties, Echo Band guarantees an unforgettable musical experience tailored to your event's theme and vibe."
        ],
        experience: [
            "Live Band Performances",
            "Vast Music Genre Range",
            "Event Customization",
            "Professional Sound Setup",
            "Entertainment for All Ages"
        ],
        services: [
            "Live Music Performances",
            "Event-Specific Music Coordination",
            "Custom Playlist Creation",
            "Sound and Lighting Setup",
            "Full Event Coverage"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book Echo Band for my event?",
                content: "Booking Echo Band is easy! Visit our website, fill out the booking form, or contact us by phone or email to discuss your event and secure a date."
            },
            {
                id: 2,
                heading: "Can I request specific songs for my event?",
                content: "Absolutely! We work with you to create a customized playlist, ensuring the music selection aligns with your event's atmosphere and guest preferences."
            },
            {
                id: 3,
                heading: "What is the cost for booking the band?",
                content: "Pricing depends on the event's size, location, and duration. We offer competitive rates and will provide a detailed quote based on your specific needs."
            },
            {
                id: 4,
                heading: "Do you provide sound and lighting equipment?",
                content: "Yes, we provide professional sound and lighting equipment for your event. Our team will set up and ensure everything runs smoothly, so you can enjoy the performance stress-free."
            },
            {
                id: 5,
                heading: "What types of events do you perform at?",
                content: "We perform at a variety of events including weddings, corporate functions, private parties, festivals, and more. No matter the occasion, we tailor our performance to match the vibe."
            }
        ],
        location: {
            description: "Located in New York, Echo Band is ready to perform at your special event. Whether it's a wedding, corporate event, or private party, we promise an electrifying experience with music tailored just for you.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317746.0289242525!2d-73.985014!3d40.758896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259b0f7ed17b3%3A0x9a1b6b11624a69b0!2sEcho%20Band%2C%20New%20York%2C%20NY!5e0!3m2!1sen!2s!4v1727280437734!5m2!1sen!2s"
        },
        gallery: [
            images.entertainment3Gallery1,
            images.entertainment3Gallery2,
            images.entertainment3Gallery3,
            images.entertainment3Gallery4,
            images.entertainment3Gallery5,
            images.entertainment3Gallery6,
            images.entertainment3Gallery7,
            images.entertainment3Gallery8,
            images.entertainment3Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.entertainment3Review1,
                name: "Emily White",
                date: "April 20, 2024",
                rating: 5,
                content: "Echo Band made our wedding reception unforgettable! The music was perfect, and everyone danced all night. Highly recommended!"
            },
            {
                id: 2,
                image: images.entertainment3Review2,
                name: "Oliver King",
                date: "March 30, 2024",
                rating: 4.9,
                content: "The performance was incredible! Echo Band truly brought the energy and made our event feel special. Everyone loved the variety of music."
            }
        ]
    },
    {
        id: 24,
        image: images.entertainment4,
        title: "Melody Duo",
        content: "Melody Duo is a talented pair of musicians offering live performances that combine acoustic and contemporary styles, perfect for intimate weddings and events.",
        details: {
            category: "Music Entertainment",
            phoneNumber: "(555) 432-1234",
            email: "info@melodyduo.com",
            website: "www.melodyduo.com",
            location: "Harmony Street, 321 Melody Lane, Los Angeles, CA",
            priceRange: "$1,500 - $7,500",
            availability: "Available for weddings, private parties, corporate events, and intimate gatherings",
            specialties: "Acoustic performances, duet music arrangements, live event customization",
            businessHours: "Mon - Fri: 10:00 AM - 6:00 PM"
        },
        overviews: [
            "Melody Duo brings an enchanting blend of acoustic and contemporary music to your event, offering soulful performances for weddings and special gatherings. Their sound is ideal for creating an intimate, warm atmosphere.",
            "Whether it's a wedding, corporate event, or private gathering, Melody Duo ensures a memorable musical experience that complements your event perfectly."
        ],
        experience: [
            "Live Acoustic Performances",
            "Tailored Music Selections",
            "Intimate Event Ambiance",
            "Versatile Music Genres",
            "Professional Sound Setup"
        ],
        services: [
            "Custom Song Requests",
            "Personalized Event Music",
            "Acoustic and Modern Performance",
            "Elegant Live Music Experience",
            "Event-Specific Music Coordination"
        ],
        faqs: [
            {
                id: 1,
                heading: "How can I book Melody Duo for my event?",
                content: "Booking Melody Duo is easy! Visit our website, fill out the contact form, or reach us by phone or email to discuss your event and secure your booking."
            },
            {
                id: 2,
                heading: "Can I request specific songs for my event?",
                content: "Absolutely! We love to personalize our performances. You can request specific songs, and we'll ensure they’re included in the setlist to match your event's vibe."
            },
            {
                id: 3,
                heading: "What is the cost for booking Melody Duo?",
                content: "Our pricing varies based on event size, location, and duration. Contact us directly to receive a customized quote tailored to your event."
            },
            {
                id: 4,
                heading: "Do you provide sound equipment for events?",
                content: "Yes, we provide high-quality sound equipment for our performances. We ensure that everything is set up and tested before your event to guarantee a smooth experience."
            },
            {
                id: 5,
                heading: "What types of events do you perform at?",
                content: "We perform at a range of events, including weddings, private parties, corporate events, and intimate gatherings. We tailor our music to suit the atmosphere of your event."
            }
        ],
        location: {
            description: "Located in Los Angeles, Melody Duo provides personalized music experiences for your events. Our performances are perfect for weddings, parties, and intimate gatherings.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317748.7637281327!2d-118.243684!3d34.052235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c54e4d0b9b8d%3A0x254a56c96a7f5399!2sMelody%20Duo%2C%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2s!4v1727282055390!5m2!1sen!2s"
        },
        gallery: [
            images.entertainment4Gallery1,
            images.entertainment4Gallery2,
            images.entertainment4Gallery3,
            images.entertainment41Gallery4,
            images.entertainment4Gallery5,
            images.entertainment4Gallery6,
            images.entertainment4Gallery7,
            images.entertainment4Gallery8,
            images.entertainment4Gallery9,
        ],
        comments: [
            {
                id: 1,
                image: images.entertainment4Review1,
                name: "Sophia Green",
                date: "March 12, 2024",
                rating: 5,
                content: "Melody Duo made our wedding so special with their beautiful acoustic performance. The music was so perfect for our ceremony, and our guests loved it!"
            },
            {
                id: 2,
                image: images.entertainment4Review2,
                name: "Liam Harris",
                date: "April 4, 2024",
                rating: 4.8,
                content: "The duo was amazing! They created the perfect atmosphere for our reception with their blend of acoustic tunes and modern hits."
            }
        ]
    }
];

export default vendors;